import { render } from "./LessonsSelection.vue?vue&type=template&id=5ac6726c&scoped=true"
import script from "./LessonsSelection.vue?vue&type=script&lang=js"
export * from "./LessonsSelection.vue?vue&type=script&lang=js"

import "./LessonsSelection.vue?vue&type=style&index=0&id=5ac6726c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/JEEducation.Student_STAGING/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac6726c"]])

export default __exports__